var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96534 15.1698C5.41324 15.3178 5.13719 15.3917 5.04753 15.6345C4.95788 15.8773 5.10656 16.0939 5.40393 16.5272C5.72068 16.9888 6.08649 17.418 6.49671 17.8068C7.6189 18.8704 9.02527 19.5861 10.5457 19.8672C12.0661 20.1483 13.6353 19.9827 15.0636 19.3906C16.4919 18.7985 17.718 17.8052 18.5936 16.5309C19.4692 15.2565 19.9568 13.7557 19.9973 12.2101C20.0378 10.6645 19.6295 9.14022 18.8219 7.82175C18.0143 6.50328 16.8419 5.44709 15.4466 4.78098C14.5556 4.3556 13.598 4.10093 12.623 4.02477C12.099 3.98384 11.837 3.96337 11.6716 4.1624C11.5062 4.36143 11.5802 4.6375 11.7281 5.18963L13.3712 11.3219L13.3738 11.3314C13.3862 11.3764 13.4279 11.5282 13.4473 11.6789C13.4741 11.8862 13.4907 12.2937 13.2452 12.7189C12.9998 13.144 12.6385 13.3334 12.4456 13.4139C12.3054 13.4724 12.1531 13.5122 12.1079 13.524L12.0985 13.5265L5.96534 15.1698Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67063 3.30667C9.54649 2.84338 9.48442 2.61174 9.28694 2.51053C9.08946 2.40932 8.87978 2.48868 8.46042 2.64739C7.54796 2.99272 6.68924 3.47037 5.91239 4.06647C4.87054 4.8659 3.99636 5.86272 3.33975 7C2.68314 8.13728 2.25696 9.39275 2.08555 10.6947C1.95774 11.6656 1.97344 12.6481 2.13061 13.6109C2.20284 14.0535 2.23896 14.2747 2.42535 14.3952C2.61174 14.5156 2.84338 14.4535 3.30667 14.3294L11.0341 12.2588C11.4894 12.1368 11.7171 12.0758 11.8206 11.8964C11.9242 11.7171 11.8632 11.4894 11.7412 11.0341L9.67063 3.30667Z",
    fill: "#F4F5F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsHover);
export default __webpack_public_path__ + "static/media/reportsHover.1b3b1b3ecf921899cda5b829b731c582.svg";
export { ForwardRef as ReactComponent };